module.exports = __webpack_public_path__ + "static/media/report_empty_state_image.0f7781a1.png";